import React from "react"
import { Row } from "antd"
import warningIcon from "app/styles/images/sp/warning.svg"

import "./downloadChrome.scss"

const windowsAd=
"https://dpcp-dev.pek3a.qingstor.com/chrome/google-chrome-59.0.3071.86_x64.exe"
const macAd =
"https://dpcp-dev.pek3a.qingstor.com/chrome/google-chrome-59-0-3071-86.dmg"
const downloadAddress = /macintosh|mac os x/i.test(navigator.userAgent) ? macAd : windowsAd

export default class DownloadChrome extends React.Component {
  componentWillMount() {
    if (this.isChrome()) {
      this.props.history.push("login")
    }
  }

  isChrome = () => {
    return /chrome\/([\d.]+)/.test(navigator.userAgent.toLowerCase())
  }

  render() {
    return (
      <div className="download-chrome-container">
        <h1 className="logo-img"></h1>
        <Row className="warning-message" type="flex" justify="center" align="middle">
          <img src={warningIcon} alt="" />
          <div>为了您的数据安全，请使用Chrome浏览器登录</div>
        </Row>
        <div className="chrome-logo"></div>
        <a href={downloadAddress} className="download-btn cursor-p">下载最新版本Chrome浏览器</a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/downloadChrome/DownloadChrome.js